import {
  POPOVER_CONTENT_DELAY,
  POPOVER_CONTENT_OFFSET_X_COLLAPSED,
  POPOVER_CONTENT_OFFSET_X_EXPANDED,
} from '~/components/Navigation/constants';
import NavMenuHead from '.';
import NavMenuPopover from '../../../NavMenuPopoverContent';
import { NavMenuHeadWithPopoverProps } from '../../types';

const MenuHeaderWithPopover = (props: NavMenuHeadWithPopoverProps) => {
  const {
    isCollapsed,
    isMenuClosed,
    subMenu,
    menuName,
    menuId,
    intl,
    activeRouteId,
    isLoading,
    isSubMenuVisible,
  } = props;

  if (isCollapsed || isMenuClosed) {
    return (
      <NavMenuPopover
        intl={intl}
        menuId={menuId}
        subMenu={subMenu}
        menuName={menuName}
        isLoading={isLoading}
        isSubMenuVisible={isSubMenuVisible}
        activeRouteId={activeRouteId}
        popoverDelay={!isCollapsed ? POPOVER_CONTENT_DELAY : 0}
        offsetX={
          isCollapsed ? POPOVER_CONTENT_OFFSET_X_COLLAPSED : POPOVER_CONTENT_OFFSET_X_EXPANDED
        }
      >
        <span>
          <NavMenuHead {...props} />
        </span>
      </NavMenuPopover>
    );
  }

  return <NavMenuHead {...props} />;
};

export default MenuHeaderWithPopover;
